import { FileCreateDto } from "@models/ui-models/files";
import { UIProfile } from "../organisations/ui-profile";

export class NoteRecord {
  id: string;
  text: string;
  entityId: string | null;
  individualId: string | null;
  attachmentsToUpload: FileCreateDto[];
  attachmentsName: string[];
  userId: string | null;
  user: UIProfile | null;
  modifiedOn: Date;

  constructor(data: Partial<NoteRecord> = {}) {
    this.id = data.id ?? '';
    this.text = data.text ?? '';
    this.entityId = data.entityId ?? null;
    this.individualId = data.individualId ?? null;
    this.attachmentsToUpload = data.attachmentsToUpload ?? [];
    this.attachmentsName = data.attachmentsName ?? [];
    this.userId = data.userId ?? null;
    this.user = data.user ?? null;
    this.modifiedOn = data.modifiedOn ? new Date(data.modifiedOn) : new Date();
  }

  toJSON() {
    const { user, ...rest } = this;
    return { ...rest };
  }
}
